const ORDER_NOT_SAME_CITY_ALL = 0;
const ORDER_NOT_SAME_CITY_WAIT_PAY = 1;
const ORDER_NOT_SAME_CITY_WAIT_CONSIGNMENT = 2;
const ORDER_NOT_SAME_CITY_WAIT_CUSTOMER_RECEIPT = 3;
const ORDER_NOT_SAME_CITY_WAIT_APPRAISE = 4;
const ORDER_NOT_SAME_CITY_AFTER_SALE = 5;

const ORDER_SAME_CITY_ALL = 0;
const ORDER_SAME_CITY_WAIT_PAY = 1;
const ORDER_SAME_CITY_WAIT_DELIVER_RECEIPT = 2;
const ORDER_SAME_CITY_DELIVERING = 3;
const ORDER_SAME_CITY_ARRIVED = 6;
const ORDER_SAME_CITY_WAIT_APPRAISE = 4;
const ORDER_SAME_CITY_AFTER_SALE = 5;

const ORDER_SELF_PICK_CITY_ALL = 0;
const ORDER_SELF_PICK_CITY_WAIT_PAY = 1;
const ORDER_SELF_PICK_CITY_WAIT_PICK = 2;
const ORDER_SELF_PICK_CITY_WAIT_APPRAISE = 4;
const ORDER_SELF_PICK_CITY_AFTER_SALE = 5;

const ORDER_WAIT_PAY = 1; // 待支付
const ORDER_WAIT_CONSIGNMENT = 2; // 待发货
const ORDER_WAIT_CUSTOMER_RECEIVE = 3; // 待收货
const ORDER_WAIT_PRAISE = 4; // 待评价
const ORDER_AFTER_SALE = 5; // 售后
const ORDER_ARRIVED = 6; // 已送达
const ORDER_PRAISE_SUCCESS = 7; // 已评价
const ORDER_CANCEL = 9; // 已取消

const ORDER_NOT_SAME_CITY = 1;
const ORDER_SAME_CITY = 2;
const ORDER_SELF_PICK = 3;

export 
{
    ORDER_NOT_SAME_CITY_ALL,
    ORDER_NOT_SAME_CITY_WAIT_PAY,
    ORDER_NOT_SAME_CITY_WAIT_CONSIGNMENT,
    ORDER_NOT_SAME_CITY_WAIT_CUSTOMER_RECEIPT,
    ORDER_NOT_SAME_CITY_WAIT_APPRAISE,
    ORDER_NOT_SAME_CITY_AFTER_SALE,

    ORDER_SAME_CITY_ALL,
    ORDER_SAME_CITY_WAIT_PAY,
    ORDER_SAME_CITY_WAIT_DELIVER_RECEIPT,
    ORDER_SAME_CITY_DELIVERING,
    ORDER_SAME_CITY_ARRIVED,
    ORDER_SAME_CITY_WAIT_APPRAISE,
    ORDER_SAME_CITY_AFTER_SALE,

    ORDER_SELF_PICK_CITY_ALL,
    ORDER_SELF_PICK_CITY_WAIT_PAY,
    ORDER_SELF_PICK_CITY_WAIT_PICK,
    ORDER_SELF_PICK_CITY_WAIT_APPRAISE,
    ORDER_SELF_PICK_CITY_AFTER_SALE,

    //
    ORDER_WAIT_PAY,
    ORDER_WAIT_CONSIGNMENT,
    ORDER_WAIT_CUSTOMER_RECEIVE,
    ORDER_WAIT_PRAISE,
    ORDER_AFTER_SALE,
    ORDER_ARRIVED,
    ORDER_PRAISE_SUCCESS,
    ORDER_CANCEL,

    //
    ORDER_NOT_SAME_CITY,
    ORDER_SAME_CITY,
    ORDER_SELF_PICK,
}

export default {
    ORDER_NOT_SAME_CITY_ALL,
    ORDER_NOT_SAME_CITY_WAIT_PAY,
    ORDER_NOT_SAME_CITY_WAIT_CONSIGNMENT,
    ORDER_NOT_SAME_CITY_WAIT_CUSTOMER_RECEIPT,
    ORDER_NOT_SAME_CITY_WAIT_APPRAISE,
    ORDER_NOT_SAME_CITY_AFTER_SALE,

    ORDER_SAME_CITY_ALL,
    ORDER_SAME_CITY_WAIT_PAY,
    ORDER_SAME_CITY_WAIT_DELIVER_RECEIPT,
    ORDER_SAME_CITY_DELIVERING,
    ORDER_SAME_CITY_ARRIVED,
    ORDER_SAME_CITY_WAIT_APPRAISE,
    ORDER_SAME_CITY_AFTER_SALE,

    ORDER_SELF_PICK_CITY_ALL,
    ORDER_SELF_PICK_CITY_WAIT_PAY,
    ORDER_SELF_PICK_CITY_WAIT_PICK,
    ORDER_SELF_PICK_CITY_WAIT_APPRAISE,
    ORDER_SELF_PICK_CITY_AFTER_SALE,

    //
    ORDER_WAIT_PAY,
    ORDER_WAIT_CONSIGNMENT,
    ORDER_WAIT_CUSTOMER_RECEIVE,
    ORDER_WAIT_PRAISE,
    ORDER_AFTER_SALE,
    ORDER_ARRIVED,
    ORDER_PRAISE_SUCCESS,
    ORDER_CANCEL,

    //
    ORDER_NOT_SAME_CITY,
    ORDER_SAME_CITY,
    ORDER_SELF_PICK,
}